import i from "./_castSlice.js";
import c from "./_hasUnicode.js";
import m from "./_stringToArray.js";
import f from "./toString.js";
function d(t) {
  return function(r) {
    r = f(r);
    var o = c(r) ? m(r) : void 0, a = o ? o[0] : r.charAt(0), e = o ? i(o, 1).join("") : r.slice(1);
    return a[t]() + e;
  };
}
export {
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_createCaseFirst.js
// module id = 1463
// module chunks = 41